import { Link } from "react-router-dom";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  withText?: boolean;
}

const Logo = ({ size = "md", withText = true }: LogoProps) => {
  const sizeConfig = {
    sm: { classes: "w-8 h-8", width: 32, height: 32 },
    md: { classes: "w-10 h-10", width: 40, height: 40 },
    lg: { classes: "w-12 h-12", width: 48, height: 48 },
  };

  return (
    <Link to="/" className="flex items-center gap-x-2">
      <div className={`${sizeConfig[size].classes} rounded-full overflow-hidden shadow-md bg-brand-yellow`}>
        <img 
          src="/images/logo.png" 
          alt="Prebitit Logo" 
          className="w-full h-full object-cover"
          width={sizeConfig[size].width}
          height={sizeConfig[size].height}
          decoding="async"
        />
      </div>
      {withText && (
        <span className="text-2xl font-bold bg-gradient-to-r from-brand-black to-brand-yellow bg-clip-text text-transparent">
          Prebitit
        </span>
      )}
    </Link>
  );
};

export default Logo;
